import type { App } from 'vue'

export async function replaceVideoPlaceholders() {
  const placeholders = document.querySelectorAll('.video-placeholder')

  for (const el of placeholders) {
    const videoId = el.getAttribute('data-video-id')

    if (videoId) {
      // Fetch fresh video URL
      const { data } = await useApiStoreless(`/library/${videoId}`)
      const response: any = data.value

      if (response?.cloudUrl) {
        // Replace the placeholder div with a real video element
        ;(el as HTMLImageElement).src = response.cloudUrl
      }
    }
  }
}

export default function (app: App) {
  app.use(replaceVideoPlaceholders)
}
